<script>
import NavBar from "@/components/nav-bar";
import RightBar from "@/components/right-bar";
import Footer from "@/components/footer";
import Menu from "@/components/menu.vue";
import ApplicationLogo from "@/components/application-logo.vue";
import { systemState } from "@/helpers/system-status";

/**
 * Horizontal layout (System Configuration > Appearance > Layout): the menu across the
 * top, under the topbar. The menu is the signed-in user's own (Menu: the menus their
 * roles and OU allow, as in the vertical layout).
 */
export default {
  components: {
    NavBar,
    RightBar,
    Footer,
    Menu,
    ApplicationLogo,
  },
  data() {
    return {
      ouLogo: localStorage.getItem("ouLogo"),
    };
  },
  computed: {
    // The Theme Customizer (gear), when people may set their own theme.
    allowUserTheme() {
      return systemState.allowUserTheme;
    },
  },
  created() {
    document.documentElement.setAttribute("data-layout", "horizontal");
  },
  methods: {
    handleOUSelected(selectedValue) {
      this.ouLogo = selectedValue;
    },
  },
};
</script>

<template>
  <div>
    <div id="layout-wrapper">
      <NavBar @ouSelected="handleOUSelected" />
      <!-- ========== App Menu ========== -->
      <div class="app-menu navbar-menu">
        <!-- LOGO (shown when the menu collapses on small screens) -->
        <div class="navbar-brand-box">
          <router-link to="/" class="logo logo-dark">
            <span class="logo-sm"><application-logo :imageUrl="ouLogo || undefined" :size="'sm'" /></span>
            <span class="logo-lg"><application-logo :imageUrl="ouLogo || undefined" /></span>
          </router-link>
          <router-link to="/" class="logo logo-light">
            <span class="logo-sm"><application-logo :imageUrl="ouLogo || undefined" :size="'sm'" /></span>
            <span class="logo-lg"><application-logo :imageUrl="ouLogo || undefined" /></span>
          </router-link>
        </div>
        <div id="scrollbar">
          <!-- The user's menus (by their permissions). -->
          <Menu />
        </div>
      </div>
      <!-- Vertical Overlay-->
      <div class="vertical-overlay"></div>

      <div class="main-content">
        <div class="page-content">
          <b-container fluid>
            <slot />
          </b-container>
        </div>
        <Footer />
      </div>
      <RightBar v-if="allowUserTheme" />
    </div>
  </div>
</template>

<style>
/* The menu bar: each label on one line (the menus that don't fit go under "More"). */
[data-layout="horizontal"] .navbar-menu .navbar-nav > .nav-item > .nav-link { white-space: nowrap; }
/* "More" is the last item: its dropdown keeps to the right edge, its submenus open to the left. */
[data-layout="horizontal"] .navbar-menu .menu-more > .menu-dropdown { left: auto; right: 0; }
[data-layout="horizontal"] .navbar-menu .menu-more .menu-dropdown .menu-dropdown { left: auto; right: 100%; }
/* The topbar's color across the whole width (the app colors it on its inner bar). */
[data-layout="horizontal"] #page-topbar { background-color: var(--vz-success); border-color: var(--vz-success); }
html[data-palette="aai"][data-layout="horizontal"] #page-topbar { background-color: #c40000; border-color: #c40000; }
html[data-palette="aai"][data-layout="horizontal"][data-topbar="light"] #page-topbar { background-color: #141416; border-color: #141416; }
</style>
